module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/extroversion/4d39a3839737d8fbb33f7ee4df998032.png";